import toast, { Toaster } from 'react-hot-toast'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './App.css'
import Routers from './routes/Routers'

export const queryClient = new QueryClient()

const App = () => {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Routers />
      </QueryClientProvider>
      <div onClick={() => toast.dismiss()}>
        <Toaster
          containerStyle={{ inset: "0px", marginTop: "20px" }}
          toastOptions={{
            duration: 2000,
          }}
        />
      </div>
    </>
  )
}

export default App
